import { Flex } from "@chakra-ui/react";

import useProductLocalization from "components/hooks/Localization/useProductLocalization";
import { OFText } from "design_system/components/OFText";
import { StripeProductLocaleKeys } from "graphql/generated";
import { colors } from "src/colors";
import getNameProp from "src/utils/getNameProp";

type Props = {
  displayId: string;
  fallbackPrice: string;
  t: any;
};

export const PriceFormat = ({ t, fallbackPrice, displayId }: Props): JSX.Element => {
  const { getTranslatedText } = useProductLocalization();

  const displayPriceText = getTranslatedText(displayId, StripeProductLocaleKeys.DisplayPrice);
  const quantityPerUnitText = getTranslatedText(displayId, StripeProductLocaleKeys.QuantityPerUnit);

  const displayPrice = displayPriceText === "" ? fallbackPrice : displayPriceText;
  const unit =
    quantityPerUnitText === ""
      ? getTranslatedText(displayId, StripeProductLocaleKeys.Unit)
      : quantityPerUnitText;

  return (
    <Flex {...getNameProp("product-price-quantity")}>
      <OFText color={colors.white.default} textStyle="body3">
        {t("shop:from_price_format", { price: displayPrice })}
      </OFText>
      <OFText color={colors.white.default} textStyle="body3">
        &nbsp;/ {unit}
      </OFText>
    </Flex>
  );
};
